/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
const Potree = window.Potree;
import store from '@/store';
import { getAllLeafComponents, pointerToRaycaster, getBBBox, getFragIdFromDbId, setPermeativeElementsTheme, setModelVisibility, isolateForge, clearThemingColors, setModelTransparency, getLeafsObjectsAsync } from '../utils/forgeUtils'
import { DisplaySettings, ForgeEquipment } from './../scripts/js/forgeModels';
import { restoreStateToViewer3d } from './../scripts/js/forgeviewer';
import { forgeFetch } from '@/utils/mongoUtils'
import { isSamePoint } from '@/utils/threejsUtils'
const THREE = window.THREE;
import { ModelBrowserItem } from './../scripts/js/forgeModels';


class MainExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;

        this.mappedMaterial = {};
        this.tagsMapped = false;
        this._timer;
        this._pointclouds;
        this._pointCloudGroups;
        this.initFocalLength;
        this.isMovingScaffold = false;
        this.isScalingScaffold = false;
        this.modelLoaded = false;
        this.pinClassName = 'pinned-point-3d'

        var _this = this;
        this.viewer.registerContextMenuCallback( 'reality-context-menu', ( menu, status ) => {
            let showAllObjects = menu.find(o=>o.title === 'Show All Objects');

            if (showAllObjects) {
                let original = showAllObjects.target;
                showAllObjects.target = () => {
                    this.endIsolation();
                    original();
                }
            }

            if(status.hasSelected) {
                menu.push({
                    title: 'Crop Selected',
                    target: () => {
                        _this.cropSelectedElements();
                    }
                });
                menu.push({
                    title: 'Add Tag',
                    target: () => {
                        let center = getBBBox(_this.viewer.getSelection()).getCenter()
                        let point = store.state.forgeService.view3dToWorld(center)
                        store.state.forgeService.addNewTag("3d",point,null,true);
                    }
                });
            }
            if(store.state.mouseDownHitTest&&store.state.mouseDownHitTest.point){
                var closestImage = store.state.forgeService.getClosestImageToPoint(store.state.mouseDownHitTest.point);
                menu.push({
                    title: 'Nearest 360',
                    target: () => {
                        store.state.forgeService.openNearest360ToPoint(store.state.mouseDownHitTest.point, (isImageLoaded) => {
                            let isLinkedViewers = store.state.areViewsLocked
            
                            if (isLinkedViewers) { 
                                store.state.forgeService.zoomToPointIn3DAnd360(store.state.mouseDownHitTest.point);
                            } else {
                                store.state.forgeService.zoomToPointIn360Viewer(store.state.mouseDownHitTest.point);
                                store.state.forgeService.zoomToPoint3dViewer(store.state.mouseDownHitTest.point);
                            }
                        });
                    }
                });
            }

        });
        
    }

    load() {
        var _this = this;
        this.viewer.addEventListener(Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT, () => {
            store.commit("setIsTreeLoaded", true);
            this.initFocalLength = this.viewer.getFocalLength();
            this.syncTagsToViewer();
            this.updatePinPoint();
        });
        this.viewer.addEventListener(Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT, () => {
            if (store.state.fetchedState&&store.state.fetchedState.viewer3DSettings)
                restoreStateToViewer3d();
            else if(store.state.forgeService.image360ToNavigateToIn3D){
                store.state.forgeService.navigateIn3D(store.state.forgeService.image360ToNavigateToIn3D);
                store.state.forgeService.image360ToNavigateToIn3D = null;
            }
            else if (store.state.forgeService.modelToNavigateToIn3D) {
                store.state.forgeService.toggleShowingModel(store.state.forgeService.modelToNavigateToIn3D);
                store.state.forgeService.modelToNavigateToIn3D = null
            }
            else if (store.state.forgeService.cameraToNavigateToIn3D) {
                store.state.forgeService.cameraToNavigateToIn3D.load();
                store.state.forgeService.cameraToNavigateToIn3D = null
            } 
            else if (store.state.selectedImage) {
                store.state.forgeService.navigateIn3D(store.state.selectedImage);
            }
            
            if (store.state.forgeService.pointCloudsToShowIn3D){
                for (let i = 0; i < store.state.forgeService.pointCloudsToShowIn3D.length; i++) {
                    const pointCloud = store.state.forgeService.pointCloudsToShowIn3D[i];
                    store.state.forgeService.toggleShowingPointCloudIn3D(pointCloud);
                }
                store.state.forgeService.pointCloudsToShowIn3D = []
            }
        });

        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, (e) => {
            if(!_this.viewer||!_this.viewer.model)
                return;
            store.state.forgeService.toggleCrossHairCursorToViewer(!!store.state.isPickingPin, this.viewer)

            store.state.forgeService.updateLabelsPositionsByClassName(this.pinClassName, this.viewer)
            let modelCameraPostion = store.state.forgeService.view3dToWorld(e.camera.position);

            store.commit("setCamera3dPosition", modelCameraPostion)

            //update plan 2D direction
            var planExtension = store.state.forgeService.getDrawPointsExtension();
            if (planExtension)
                planExtension.drawDirection2D();

            if (store.state.forgeService.startedPanoChange
                || !store.state.selectedImage
                || !store.state.selectedImage.isLocked
                || !store.state.areViewsLocked)
                return;

            if (store.state.selectedImage.forgeCameraPosition) {
                var currentPosition = _this.viewer.navigation.getPosition();
                var viewerCamPosition = store.state.selectedImage.getCameraPositionInViewer();
                if (viewerCamPosition.x != currentPosition.x
                    || viewerCamPosition.y != currentPosition.y
                    || viewerCamPosition.z != currentPosition.z) {
                        store.state.areViewsLocked = false;
                    return;
                }
            }
            store.state.forgeService.updatePanoViewerFromForge(store.state.selectedImage);
        });
        this.viewer.addEventListener(Autodesk.Viewing.CUTPLANES_CHANGE_EVENT, (ev) => {
            store.state.cropBoxApplied = !!ev.planes
        });
        // this.viewer.addEventListener(Autodesk.Viewing.CUTPLANES_CHANGE_EVENT, () => {
        //     if(!_this._pointclouds)
        //         return;
        //     setTimeout(() => {

        //         var pointclouds = Array.from(_this._pointclouds.values());
        //         if (pointclouds.length == 0)
        //             return;
        //         let extension = _this.viewer.getExtension('Autodesk.Section');
        //         if (!extension || !extension.isActive())
        //             return;
        //         let cropBox = null;
        //         let planes = extension.getSectionPlanes(true);
        //         if (!planes || planes.length == 0)
        //             return;
        //         if (extension.mode == 'box') {
        //             if (planes.length == 6) {
        //                 let min = new THREE.Vector3(planes[3].w, planes[4].w, planes[5].w);
        //                 let max = new THREE.Vector3(-planes[0].w, -planes[1].w, -planes[2].w);
        //                 cropBox = new THREE.Box3(min, max);
        //             }
        //         } else if (extension.mode == 'x') {
        //             let min = new THREE.Vector3(planes[0].w, -Infinity, -Infinity);
        //             let max = new THREE.Vector3(Infinity, Infinity, Infinity);
        //             cropBox = new THREE.Box3(min, max);
        //         } else if (extension.mode == 'y') {
        //             let min = new THREE.Vector3(-Infinity, planes[0].w, -Infinity);
        //             let max = new THREE.Vector3(Infinity, Infinity, Infinity);
        //             cropBox = new THREE.Box3(min, max);
        //         } else if (extension.mode == 'z') {
        //             let min = new THREE.Vector3(-Infinity, -Infinity, -Infinity);
        //             let max = new THREE.Vector3(Infinity, Infinity, -planes[0].w);
        //             cropBox = new THREE.Box3(min, max);
        //         }

        //         pointclouds.forEach(o => o.setClippingBoxNew(cropBox));
        //         //drawBoxLines(cropBox)
        //     }, 100);

        // });
        this.viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, (event) => 
        {
            let bounding = this.viewer.model.getBoundingBox();

            let unitScale = this.viewer.model.getUnitScale() ?? 1

            let isLargeModel = Math.abs(bounding.max.x) * unitScale > 1500 / unitScale || Math.abs(bounding.max.y) * unitScale > 1500 / unitScale

            store.commit('setIsLargeModel', isLargeModel);

            if (isLargeModel) this.viewer.impl.setNearRadius(0);
            
            store.state.forgeService.updateAll3DIcons();

            let model = event.model;

            let fps = store.state.userSettings.displaySettings.renderFPS ?? 8;
            this.viewer.impl.setFPSTargets(undefined, fps, fps);

            if (store.state.dbidsToLoad?.length) {
                this.viewer.isolate(store.state.dbidsToLoad);
                this.viewer.fitToView();
                this.viewer.autocam.setCurrentViewAsHome(true);
            }

            // let modelSize = model.getGeometryList().geomMemory / (1024 * 1024);
            // if ((modelSize > 150 && modelSize < 300) || store.state.dbidsToLoad) {
            //     this.viewer.impl.setFPSTargets(undefined, 10, 10)
            // } else if (modelSize > 300) {
            //     this.viewer.impl.setFPSTargets(undefined, 5, 5)
            // }
            let urn = model.getSeedUrn();
            let smallModel = store.state.uploadedModels.find(o=>o.urn == urn);
            if (smallModel && !store.state.forgeService.smallModelsUrnsPerElements.get(smallModel.urn)) {
                // let dbIds = [...new Set(viewer.model.getFragmentList().fragments.fragId2dbId)];
                getAllLeafComponents(model,(dbIds) => {
                    //add data to elements
                    var elements = [];
                    for (var i = 0; i < dbIds.length; i++) {
                        let elem = store.state.forgeService.dbidToForgeObject(dbIds[i], model);
                        elem.urn = smallModel.urn;
                        elements.push(elem);
                    }
                    store.state.forgeService.smallModelsUrnsPerElements.set(smallModel.urn, elements);
                });
            }

            if(store.state.forgeService.tagToZoomToIn3D){
                setTimeout(() => {
                    store.state.forgeService.zoomInAllAvailableViewers(store.state.forgeService.tagToZoomToIn3D, true);
                    store.state.forgeService.tagToZoomToIn3D = null;
                }, 0);
            } 

            _this.modelLoaded = true;

            store.state.forgeService.updateModelGray();
        });

        this.viewer.addEventListener(Autodesk.Viewing.AGGREGATE_ISOLATION_CHANGED_EVENT, (event) => {
            let settings = store.state.userSettings?.displaySettings || new DisplaySettings();

            if (!settings.showMasterModel) {
                this.viewer.model.setAllVisibility(0);
            }

            if (store.getters['getIsLargeModel'] && !!event.isolation.length) {
                let unitScale = this.viewer.model.getUnitScale() ?? 1;
                let maxLength = 100 / unitScale;
                let radius = 0;

                if (event.isolation[0].ids.length) {
                    let { ids, model } = event.isolation[0]
                    let bBox = getBBBox(ids, model);
                    let {x, y, z} = bBox.getSize();
                    if (x < maxLength && y < maxLength && z < maxLength) {
                        radius = 0.15;
                    }
                }

                this.viewer.impl.setNearRadius(radius);
            }
            
            // clear the stored themed dbids if not toggle ghosting ON in the solid mode
            if (!event.isolation.length && 
                (!store.state.isGhostingOn || (store.state.isGhostingOn&&store.state.isGhostingWireframe))) {
                let themedDbIds = store.getters['GET_THEMED_DB_IDS'];
                if (themedDbIds.length) {
                    setPermeativeElementsTheme(themedDbIds, null);
                    store.commit('SET_THEMED_DB_IDS',[]);
                }
            }
        })

        this.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, (event) => 
        {
            // Cancel open any popup if we already clicked on 3D tag.
            if (store.state.forgeService.getLabels3DExtension()?.hovered !== -1) return;
            if (store.getters['getIgnoreModelSelectionEvent']) return;

            let selection = this.viewer.getSelection();
            store.commit("setSelectedDbids", selection)

            let addingTagInfo = store.getters['GET_ADDING_TAG_INFO'];
            if (addingTagInfo) {
                store.commit("SET_ADDING_TAG_INFO", { ...addingTagInfo, selection: selection })
            }
            if (selection.length == 0) return;
            
            if (store.state.isPickingTag) {
                store.state.forgeService.createTagFromSelection();
                return;
            }

            if (store.getters["getModelElementsObject"] instanceof ModelBrowserItem) {
                store.dispatch('updateSelectedNode', { nodeId: selection[0] })
            }
        });

        this.viewer.addEventListener(Autodesk.Viewing.ISOLATE_EVENT, () => 
        {
            let isolated = this.viewer.getIsolatedNodes();
            store.commit("setIsolatedNodes", isolated)
        });
        
        return true;
    }
    onToolbarCreated() {
    }
    getAutomaticTagForSelection(dbids, callback){
        let tag = store.state.tags.find(o => o.children.some(o => o.dbId == dbids[0]));
        if (tag)
            callback(tag);
        else {
            let autoTags = store.getters['GET_AUTOMATIC_TAGS']
            tag = autoTags.find(o => o.children.some(o => o.dbId == dbids[0]));
            if (tag)
                callback(tag);
            else {
                var containingAutomaticTagId = this.getFirstContainingAutomaticTagId(dbids[0])
                if (containingAutomaticTagId) {
                    forgeFetch(`api/equipments/getAutomaticTagById?id=${containingAutomaticTagId}`, autoTag => {
                        if (autoTag) {
                            autoTag = Object.assign(new ForgeEquipment(), autoTag)
                            autoTag.parseContent()
                            autoTags.push(autoTag)
                            callback(autoTag);
                        }
                    })
                }
            }

        }
    }
    getFirstContainingAutomaticTagId(dbid){
        let existing = store.state.TAGS.allExistingAutomaticDbids.find(o=>o.dbid == dbid)
        if(existing)
            return existing.id
        var parentId = this.viewer.model.getInstanceTree()?.getNodeParentId(dbid) ?? 0
        if(parentId == 0)
            return null
        return this.getFirstContainingAutomaticTagId(parentId)
    }
    getFirstContainingAMISTagId(dbId){

        const set = store.getters.GET_ALL_AMIS_TAGS_IDS;

        let existing = set.find(t => t.children.some(c => c.dbId == dbId));

        if(existing) return existing.id

        var parentId = this.viewer.model.getInstanceTree()?.getNodeParentId(dbId)

        if(parentId == 0) return null;

        return this.getFirstContainingAMISTagId(parentId)

    }
    fitViewToPointCloudBoundary(viewer, pointCloud) {
        let d = pointCloud.boundingBox.max.sub(pointCloud.boundingBox.min);
        
        let offset = (1 / viewer.model.getUnitScale()) ;
        
        let min = new THREE.Vector3(pointCloud.position.x - (offset * d.x), pointCloud.position.y - (offset * d.y), pointCloud.position.z - (offset * d.z));
        let max = new THREE.Vector3(pointCloud.position.x + (offset * d.x), pointCloud.position.y + (offset * d.y), pointCloud.position.z + (offset * d.z));
        
        var box = new THREE.Box3(min, max);
        viewer.navigation.fitBounds(true, box);
    }

    //point cloud
    showPointCloud(cloudName, show, url) {

        store.state.mainApp.showPanoMeasureTool = store.state.pointClouds.some(o => o.isShown);

        if (!this._pointCloudGroups) this._pointCloudGroups = new Map();

        if (this._pointCloudGroups.has(cloudName)) {

            this._pointCloudGroups.get(cloudName).visible = show;

            let pc = this._pointclouds.get(cloudName)

            if (pc) {

                pc.setClippingBoxNew(store.state.forgeService.getCropping3DExtension().cropBox)

                if (show && store.state.isEmptyModel) 
                    this.fitViewToPointCloudBoundary(this.viewer, pc);
            }

            this.viewer.impl.invalidate(true, true, true);

            setTimeout(() => {
                store.commit("setShowLoading", false);
            }, 200)

            return;
        }

        if (!show) {

            setTimeout(() => {
                store.commit("setShowLoading", false);
            }, 200)

            return;
        }

        var group = new THREE.Group();

        this._pointCloudGroups.set(cloudName, group);

        if (!this.viewer.overlays.hasScene('potree-scene')) {

            this.viewer.overlays.addScene('potree-scene');
        }

        this.viewer.overlays.addMesh(group, 'potree-scene');

        if (!this._pointclouds) this._pointclouds = new Map();

        // Update point clouds on every camera change...
        this.viewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, this.updatePointClouds.bind(this));

        this._timer = setInterval(this.updatePointClouds.bind(this), 500);

        this.loadPointCloud(group, cloudName, url.replace(/%2F/gi, "/")).then(pc => {

            setTimeout(() => {
                store.commit("setShowLoading", false);
            }, 200)

            if (store.state.isEmptyModel) {
                this.fitViewToPointCloudBoundary(this.viewer, pc);
            }
        });
    }
    loadPointCloud(group,name, url) {

        if (this._pointclouds.has(name)) {
            return Promise.resolve(this._pointclouds.get(name));
        }

        return new Promise((resolve, reject) => {
            Potree.loadPointCloud(url, name, (ev) => {
                const { pointcloud } = ev;
                
                pointcloud.receiveShadow = true;
                pointcloud.castShadow = true;

                const { material } = pointcloud;
                let scaleFactor = 1 / this.viewer.model.getUnitScale();
                pointcloud.position.multiplyScalar(scaleFactor).sub(this.viewer.model.getGlobalOffset());
                pointcloud.scale.copy(new THREE.Vector3(scaleFactor, scaleFactor, scaleFactor));

                material.size = 6.0;
                material.pointColorType = Potree.PointColorType.RGB; //RGB | DEPTH | HEIGHT | POINT_INDEX | LOD | CLASSIFICATION | INTENSITY_GRADIENT
                material.pointSizeType = Potree.PointSizeType.FIXED; //ADAPTIVE | FIXED
                material.shape = Potree.PointShape.CIRCLE; //CIRCLE | SQUARE | PARABOLOID             
                
                group.add(pointcloud);
                this._pointclouds.set(name, pointcloud);
                this.updatePointClouds();
                resolve(pointcloud);
                pointcloud.setClippingBoxNew(store.state.forgeService.getCropping3DExtension().cropBox)
            });
        });
    }
    hideAllPointClouds() {

        if (!this._pointCloudGroups) return;

        store.state.pointClouds.forEach(o => o.isShown = false);

        this._pointCloudGroups.forEach(group => {

            group.visible = false;

            this.viewer.overlays.removeMesh(group, 'potree-scene');

            this.viewer.impl.invalidate(true, true, true);
        });

        this._pointCloudGroups.clear();

        this._pointclouds.clear();

        clearInterval(this._timer);

        this._timer = null;

        store.state.mainApp.showPanoMeasureTool = false;

        store.commit("setShowLoading", false);

        this.viewer.impl.invalidate(true, true, true);
    }
    getshownPointClouds(){
        let shownPointCloudsNames = store.state.pointClouds.filter(o=>o.isShown).map(o=>o.name);
        if(shownPointCloudsNames.length==0)
            return [];
        return shownPointCloudsNames.map(o => this._pointclouds.get(o)).filter(o => o);
    }
    updatePointClouds() {
        if(this.viewer==null||this.viewer.impl==null||this.viewer.impl.camera==null)
            return;
                    
        let { colorType, opacity, rgbBrightness, rgbContrast, rgbGamma, elevationMin, elevationMax, colorSchema, pointBudget, useEDL, pointSize, pointType } = store.state.userSettings.displaySettings.pointCloudDisplay;

        var pointclouds = Array.from(this._pointclouds.values());

        pointclouds.forEach(o => {
            o.pointBudget = pointBudget;
            o.material.size = pointSize ?? 2.0;
            o.material.shape = pointType === 'Circle' ? Potree.PointShape.CIRCLE : Potree.PointShape.SQUARE;
            o.material.useEDL = useEDL;
            o.material.opacity = opacity / 100.0;
            o.material.pointColorType = Potree.PointColorType[colorType];
            o.material.rgbBrightness = rgbBrightness / 100;
            o.material.rgbContrast = rgbContrast / 100;
            o.material.rgbGamma = rgbGamma / 100;
            o.material.elevationRange = [elevationMin, elevationMax];
            o.material.gradient = Potree.Gradients[colorSchema];
        })
        
        var shownPointclouds = this.getshownPointClouds();

        if (shownPointclouds.length > 0) {
            const camera = this.viewer.impl.camera; //.perspectiveCamera;
            const renderer = this.viewer.impl.glrenderer();
            Potree.updatePointClouds(shownPointclouds, camera, renderer);

            this.viewer.impl.invalidate(false,false,true);
            // //update view rendered elements
            // let selection = viewer.getSelection();
            // let newtempSelection = selection.length==0 ? [viewer.model.getFragmentList().fragments.fragId2dbId[0]]:[];
            // viewer.select(newtempSelection);
            // viewer.select(selection);
        }
    }
    onMouseUp(mouse) {
        let _this = store.state.forgeService.getMainExtension();
        if (_this.tempMesh)
            _this.viewer.impl.overlayScenes.pivot.scene.remove(_this.tempMesh)
        let closestPt = _this.pickNearestPointCloudPoint(mouse);
        if (!closestPt)
            return;
        const box = new THREE.BoxGeometry(.05, 0.05, 0.05);
        _this.tempMesh = new THREE.Mesh(
            box,
            new THREE.MeshBasicMaterial({ color: 0x0000ff })
        );
        _this.tempMesh.position.x = closestPt.x;
        _this.tempMesh.position.y = closestPt.y;
        _this.tempMesh.position.z = closestPt.z;
        this.viewer.impl.overlayScenes.pivot.scene.add(_this.tempMesh);
        this.viewer.impl.invalidate(true, true, true);
    }
    pickNearestPointCloudPoint(mouse){
        if (!this._pointCloudGroups || this._pointCloudGroups.size == 0)
            return null;
        var pointclouds = Array.from(this._pointCloudGroups.values());
        if (!pointclouds[0].visible)
            return null;
        let raycaster= pointerToRaycaster(this.viewer, mouse);
        let scene = this.viewer.impl.overlayScenes["potree-scene"].scene;
        var intesects = raycaster.intersectObject(scene, true);
        if(intesects.length==0)
            return;
        intesects.sort(function(a,b){return a.distanceToRay - b.distanceToRay})
        return intesects[0].point;
    }
    getPointCloudIntersectionWithRaycaster(raycaster){
        if (!this._pointCloudGroups || this._pointCloudGroups.size == 0)
            return null;
        var pointclouds = Array.from(this._pointCloudGroups.values());
        if (!pointclouds[0].visible)
            return null;
        let scene = this.viewer.impl.overlayScenes["potree-scene"].scene;
        var intesects = raycaster.intersectObject(scene, true);
        if (intesects.length == 0)
            return;
        intesects.sort(function (a, b) { return a.distanceToRay - b.distanceToRay })
        return intesects[0].point;
    }

    isWithinCropBox(viewerPoint){
        let extension = this.viewer.getExtension('Cropping3DExtension');
        if(extension.cropBox && extension.croppingOn)
            return extension.cropBox.containsPoint(viewerPoint);
        let croppingLevel = store.state.levels.find(o=>o.isCropped);
        if(croppingLevel){
            const bbox = croppingLevel.getViewCropBox();
            return viewerPoint.z <bbox.max.z &&viewerPoint.z >bbox.min.z;
        }
        return true;
    }
    updatePinPoint(){
        var point = store.state.pinnedPoint3d
        store.state.forgeService.clearElementsByClassName(this.pinClassName)
        if(point){
            var iconOptions = {
                position: point,
                differences: null,
                title: '',
                id: '',
                className: this.pinClassName,
                forgeViewer: this.viewer,
                onClick: () => { },
                addContent: false
            }
            store.state.forgeService.create3DIconToViewer(iconOptions);
            store.state.forgeService.updateLabelsPositionsByClassName(this.pinClassName, this.viewer)
        }
        store.state.forgeService.toggleCrossHairCursorToViewer(false, this.viewer)
        this.viewer.impl.invalidate(true,true,true)
    }

    //adding/editing tags    
    getAllTaggedChildren(elements) {
        var list = elements;
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].children == null)
                continue;
            var tagged = this.getAllTaggedChildren(elements[i].children);
            list = list.concat(tagged);
        }
        return list.filter(o => o.children == null);
    }
    async syncTagsToViewer() {
        if (!store.state.dataFetched || this.tagsMapped) return;

        getLeafsObjectsAsync(this.viewer).then((leafsObjects) => {
            store.state.forgeService.allForgeElements = leafsObjects;

            if (store.state.userSettings.displaySettings) {
                setModelVisibility(this.viewer, this.viewer.model, store.state.userSettings.displaySettings.showMasterModel);
                // setModelTransparency(this.viewer.model, store.state.userSettings.displaySettings.masterModelTransparency / 100);
            }
            this.tagsMapped = true;
        }).catch(error => {
            console.error('error', error)
        });
    }
    
    mapTagsData(tags, dbIdPerObj) {
        tags?.forEach(tag => {
            for (var i = 0; i < tag.children.length; i++) {
                if (tag.children[i].center)
                    tag.children[i].center = Object.assign(new THREE.Vector3(), tag.children[i].center);
                var existingForgeTag = dbIdPerObj[tag.children[i].dbId];
                if (!existingForgeTag || !isSamePoint(existingForgeTag.center, tag.children[i].center)) {
                    var elem = this.findElementWithSameCenter(dbIdPerObj, tag.children[i].center);
                    if (elem) {
                        tag.children[i].dbId = elem.dbId;
                        tag.children[i].name = elem.name;
                    }
                } else
                    tag.children[i].name = existingForgeTag.name;
            }
        })
    }
    findElementWithSameCenter(dbIdPerObj,center){
        for(var dbid in dbIdPerObj){
            var elem = dbIdPerObj[dbid];
            if(isSamePoint(center, elem.center))
                return elem;
        }
        return null;
    }

    isolateDbIds(dbIds, model = null) {
        this.isolatedDbids = dbIds;
        isolateForge(this.viewer,model,dbIds)
        store.commit('setIsIsolating3D', true);
        store.state.forgeService.updateGhosting();
    }
    isolateDbIdsWithoutFitView(dbIds, model = null) {
        this.isolatedDbids = dbIds;
        store.state.forgeService.cameraZoomOutByScaler(0.25);
        this.viewer.isolate(dbIds, model);
        store.commit('setIsIsolating3D', true);
        store.state.forgeService.updateGhosting(false);
    }
    selectDbIds(dbIds){
        this.viewer.select(dbIds) 
        this.viewer.utilities.fitToView();
    }
    endIsolation(){
        this.isolatedDbids = [];
        store.state.forgeService.resetObjectsMaterials();
        store.state.isGhostingOn = false;
        this.viewer.isolate([]);
        this.viewer.showAll();
        clearThemingColors(this.viewer);
        store.state.addRemove3dModeEnabled = false;
        store.state.forgeService.updateModelGray();
    }
    cropSelectedElements(){
        let box = getBBBox(this.viewer.getSelection());
        let extension = this.viewer.getExtension('Cropping3DExtension');
        extension.cropBox = box;
        extension.toggleCropbox(true);
    }
    showDbIdsWithAnimation(dbIds, options) {
        options.totalTime = options.totalTime || 1000;
        options.intervals = options.intervals || 10;
        options.skipShow  = options.skipShow  || false;
        options.skipZoom  = options.skipZoom  || false;

        let guid = THREE.Math.generateUUID();

        store.commit('SET_LAST_TIME_LINE_PROCESS_ID', guid);

        const instanceTree = this.viewer.model.getInstanceTree();
        dbIds = dbIds.filter(id => instanceTree.isNodeHidden(id));

        const modelFrags = this.viewer.model.getFragmentList();

        let primitives = [];

        dbIds.forEach(dbId => {
            instanceTree.enumNodeChildren(dbId, child => {
                primitives.push(child)
            }, true)
        });

        primitives = primitives.filter(id => instanceTree.isNodeHidden(id));

        const fragments = getFragIdFromDbId(primitives);

        const materialManager = this.viewer.impl.matman();

        fragments.forEach((fragId) => {
            this.mappedMaterial[fragId] = modelFrags.getMaterial(fragId);

            if (!this.mappedMaterial[fragId]) {
                return;
            }

            let material = this.mappedMaterial[fragId].clone();

            materialManager.addMaterial(`${guid}-${fragId}`, material, true);

            this.viewer.model.unconsolidate();

            modelFrags.setMaterial(fragId, material);
        });

        let fragProxy = this.viewer.impl.getFragmentProxy(this.viewer.model, fragments);
        fragProxy.updateAnimTransform();

        let timeUnit = options.totalTime / options.intervals;

        let initialState = this.viewer.getState();
        initialState.objectSet = null;

        if (!options.skipShow) {
            setTimeout(() => {
                this.viewer.show(dbIds);
            }, timeUnit);
        }
        
        if (!options.skipZoom) {
            setTimeout(() => {             
                this.viewer.fitToView(dbIds, this.viewer.model, false);
            }, timeUnit);

            // setTimeout(() => {
            //     if (store.getters['GET_LAST_TIME_LINE_PROCESS_ID'] === guid) {
            //         this.viewer.restoreState(initialState);
            //     }
            // }, options.totalTime)
        }

        setTimeout(() => {
            fragments.forEach((fragId) => {
                if (this.mappedMaterial[fragId])
                    modelFrags.setMaterial(fragId, this.mappedMaterial[fragId]);
            });
            
            this.viewer.impl.sceneUpdated(true);
        }, options.totalTime)

        for (let i = 1; i <= options.intervals; i++) {
            this.updateOpacity(fragments, i / options.intervals, i * timeUnit);
        }
    }
    updateOpacity(frags, opacity, delay) {
        setTimeout(() => {
            frags.forEach((fragId) => {
                let renderProxy = this.viewer.impl.getRenderProxy(this.viewer.model, [fragId]);
                if (renderProxy.material) renderProxy.material.opacity = opacity;
            });
            this.viewer.impl.sceneUpdated(true);
        }, delay);
    }
    
}
Autodesk.Viewing.theExtensionManager.registerExtension('MainExtension', MainExtension);